// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { CadastraDocumentosRequest, Types } from './types';

export function cadastraDocumentosRequest(
	token: string,
	payload: CadastraDocumentosRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRA_DOCUMENTOS_REQUEST,
		token,
		payload,
	};
}

export function cadastraDocumentosSuccess(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRA_DOCUMENTOS_SUCCESS,
		payload: null,
	};
}

export function cadastraDocumentosFailure(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRA_DOCUMENTOS_FAILURE,
		payload: null,
	};
}

export function limpaCadastraDocumentos(): ReducerActionRotaSP {
	return {
		type: Types.LIMPA_CADASTRA_DOCUMENTOS,
		payload: null,
	};
}
